import request from '@/utils/request'

// {TableNameStr} {date}

let UserRegionAgentApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/regionagent.UserRegionAgent/index', data, errorback);
    },
    /*添加*/
    add(data, errorback) {
        return request._post('/shop/regionagent.UserRegionAgent/add', data, errorback);
    },
     /*添加*/
    edit(data, errorback) {
        return request._post('/shop/regionagent.UserRegionAgent/edit', data, errorback);
    },
    /*信息*/
    getArea(data, errorback) {
        return request._get('/shop/regionagent.UserRegionAgent/add', data, errorback);
    },


    /*删除*/
    del(data, errorback) {
        return request._post('/shop/regionagent.UserRegionAgent/del', data, errorback);
    },

}

export default UserRegionAgentApi;



// WEBPACK FOOTER //
// ./src/api/plus/userregionagent.js